/** @jsx jsx */

import React, { Fragment as _ } from 'react';
import { keyframes } from '@emotion/core';
import { css, jsx } from '@emotion/core';
import EditMarker from 'components/UI/EditMarker';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { colors } from 'styles/variables';
import Image from 'assets/Image.svg';

const { lPink } = colors;

const EditWrapper0 = ({
  id,
  mediaParentId,
  padding = 0,
  selected,
  children,
}) => {
  return (
    <div
      css={css`
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: ${padding}px;
        box-shadow: ${selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'};
        transition: box-shadow 0.2s;
        cursor: pointer;

        &:hover {
          ${!selected && `box-shadow: 0 0 0 1px ${lPink};`}
        }

        * {
          pointer-events: ${selected ? 'auto' : 'none'};
        }

        @media (max-width: 768px) {
          padding: 5px;
        }
      `}
      onClick={e => {
        e.stopPropagation();

        if (selected) {
          return;
        }

        setCurrentBlock({ id });
      }}
    >
      {children}

      {!selected && <EditMarker />}
    </div>
  );
};

const EditWrapper1 = ({
  id,
  mediaParentId,
  editWrapperSize = '50%',
  editWrapperUseIcon = true,
  selected,
  children,
}) => {
  // return children;

  return (
    <div
      css={css`
        // position: absolute;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
      `}
    >
      {children}
      <div
        css={css`
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
        `}
      >
        <div
          className={selected ? 'image-edit-wrapper-frame-selected' : ''}
          css={css`
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: ${selected ? '75%' : editWrapperSize};
          height: ${selected ? '75%' : editWrapperSize};

        
          ${!selected &&
            `
          background: rgba(0, 0, 0, 0.1);
        `}
          
          box-shadow: ${
            selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey'
          };

          transition: all 0.2s;

          cursor: pointer;
          &:hover {
            ${!selected && `box-shadow: 0 0 0 1px ${lPink};`}
          }
        `}
          onClick={e => {
            e.stopPropagation();

            if (selected) {
              return;
            }

            setCurrentBlock({ id });
          }}
        >
          {!selected && editWrapperUseIcon && (
            <img src={Image} style={{ width: 50, opacity: 0.5 }} />
          )}

          {!selected && <EditMarker />}
        </div>
      </div>
    </div>
  );
};

const EditWrapper2 = ({ id, mediaParentId, selected, children }) => {
  return (
    <div
      css={css`
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
      `}
    >
      {children}
      <div
        css={css`
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80%;
            height: 80%;

            box-shadow: ${selected
              ? `0 0 0 1px ${lPink}`
              : '0 0 0 1px lightGrey'};
            transition: all 0.2s;
            cursor: pointer;
            &:hover {
              ${!selected && `box-shadow: 0 0 0 1px ${lPink};`}
            }
          `}
          onClick={e => {
            e.stopPropagation();
            if (selected) {
              return;
            }
            setCurrentBlock({ id });
          }}
        >
          {!selected && <EditMarker />}
        </div>
      </div>
    </div>
  );
};

const EditWrapper3 = ({
  id,
  mediaParentId,
  padding = 0,
  editWrapperPadding = 0,
  selected,
  children,
}) => {
  return (
    <div
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
      `}
    >
      {children}

      <div
        css={css({
          position: 'absolute',
          left: editWrapperPadding,
          top: editWrapperPadding,
          width: `calc(100% - ${editWrapperPadding * 2}px)`,
          height: `calc(100% - ${editWrapperPadding * 2}px)`,
          boxShadow: selected ? `0 0 0 1px ${lPink}` : '0 0 0 1px lightGrey',
          transition: 'box-shadow 0.2s',
          cursor: 'pointer',

          ...(!selected && {
            '&:hover': {
              boxShadow: `0 0 0 1px ${lPink}`,
            },
          }),
        })}
        onClick={e => {
          e.stopPropagation();

          if (selected) {
            return;
          }

          setCurrentBlock({ id });
        }}
      >
        {!selected && <EditMarker />}
      </div>
    </div>
  );
};

export { EditWrapper0, EditWrapper1, EditWrapper2, EditWrapper3 };
